import axios from "axios";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithCustomToken } from "firebase/auth";

const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG);
initializeApp(firebaseConfig);
const auth = getAuth();

const authenticateUser = async (email, password) => {
  try {
    const { data: user } = await axios.post(`/api/auth/authenticate`, {
      email: email,
      password: password,
    });

    await signInWithCustomToken(auth, user.token);
    return user;
  } catch (error) {
    console.error(`Error authenticating user: ${error}`);
  }
};

const registerUser = async (userInformation) => {
  try {
    const { data: user } = await axios.post(
      `/api/auth/register`,
      userInformation
    );

    if (user instanceof Object) {
      await signInWithCustomToken(auth, user.token);
    }

    return user;
  } catch (error) {
    console.error(`Error creating user: ${error}`);
  }
};

const forgotPassword = (email) => {
  return axios.post(`/api/auth/forgot-password`, { email });
};

const checkResetPasswordCode = async (code) => {
  return axios.post(`/api/auth/verify-password-reset-code`, { code });
};

const changePassword = async (code, newPassword) => {
  return axios.post(`/api/auth/change-password`, { code, newPassword });
};

export {
  authenticateUser,
  registerUser,
  forgotPassword,
  checkResetPasswordCode,
  changePassword,
};
